import NewspaperFilter from './NewspaperFilter'

export default NewspaperFilter
